import { useEffect, useState } from 'react';
import { getListaDeTipoOperacao, getListaTipoDocumento } from '../../../../api/capitalFlow';

const useFiltrosTabelaHook = ({ onFiltrar, presetFiltros }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [listaTipoOperacao, setListaTipoOperacao] = useState([]);
  const [listaTipoDocumento, setListaTipoDocumento] = useState([]);
  const open = Boolean(anchorEl);
  const id = open ? 'filtros-popover' : undefined;

  const filtrosIniciais = {
    nome_cedente: '',
    cpfcnpj_cedente: '',
    nome_sacado: '',
    cpfcnpj_sacado: '',
    tipo_operacao: '',
    tipo_documento: '',
    numero_documento: '',
    bordero: '',
    data_aceite_de: null,
    data_aceite_ate: null,
    venc_de: null,
    venc_ate: null,
    page: '',
    per_page: ''
  };

  const [filtros, setFiltros] = useState(filtrosIniciais);

  const handleOpen = e => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleChange = (campo, valor) => {
    setFiltros(prev => ({ ...prev, [campo]: valor }));
  };
  const formatarDataParafiltro = dataParaFormatar => {
    if (!dataParaFormatar) return null;

    const data = new Date(dataParaFormatar);

    // se for "Invalid Date"
    if (Number.isNaN(data.getTime())) {
      return null;
    }

    return data.toLocaleDateString('pt-BR');
  };

  const handleFiltrar = () => {
    const filtrosFormatados = {
      ...filtros,
      ...(filtros.data_aceite_de != null && {
        data_aceite_de: formatarDataParafiltro(filtros.data_aceite_de)
      }),
      ...(filtros.data_aceite_ate != null && {
        data_aceite_ate: formatarDataParafiltro(filtros.data_aceite_ate)
      }),
      ...(filtros.venc_de != null && {
        venc_de: formatarDataParafiltro(filtros.venc_de)
      }),
      ...(filtros.venc_ate != null && {
        venc_ate: formatarDataParafiltro(filtros.venc_ate)
      }),
      filtro_origem: 'geral'
    };

    onFiltrar?.(filtrosFormatados);
    handleClose();
  };

  const handleLimpar = () => {
    setFiltros(filtrosIniciais);
    onFiltrar?.({ ...filtrosIniciais, filtro_origem: 'abas' }, { reset: true });
    handleClose();
  };

  const handleBuscarListaTipoOperacao = () => {
    getListaDeTipoOperacao()
      .then(response => {
        const { data } = response;
        setListaTipoOperacao(data);
      })
      .catch(err => {
        console.error('erro ao buscar lista de tipo operacao');
      });
  };

  const handleBuscarListaTipoDocumento = () => {
    getListaTipoDocumento()
      .then(response => {
        const { data } = response;

        setListaTipoDocumento(data);
      })
      .catch(err => {
        console.error('erro ao buscar lista de tipo documento');
      });
  };

  useEffect(() => {
    if (presetFiltros) {
      setFiltros({
        ...filtrosIniciais,
        ...presetFiltros
      });
    }
  }, [presetFiltros]);

  useEffect(() => {
    handleBuscarListaTipoOperacao();
    handleBuscarListaTipoDocumento();
  }, []);

  const bloquearFiltroSeDataDmaisUm = (data_de, data_ate) => {
    const amanha = new Date();
    amanha.setDate(amanha.getDate() + 1);
    amanha.setHours(0, 0, 0, 0);

    const isRetroativa = data => {
      if (!data) return false;

      const d = new Date(data);
      if (Number.isNaN(d.getTime())) return false;

      d.setHours(0, 0, 0, 0);
      return d < amanha;
    };

    // true = bloqueia se pelo menos uma for retroativa
    return isRetroativa(data_de) || isRetroativa(data_ate);
  };

  const validaSeDataInicialMaiorQueFinal = (dataDe, dataAte) => {
    if (!dataDe || !dataAte) return false;

    const dDe = new Date(dataDe);
    const dAte = new Date(dataAte);

    if (Number.isNaN(dDe.getTime()) || Number.isNaN(dAte.getTime())) return false;

    dDe.setHours(0, 0, 0, 0);
    dAte.setHours(0, 0, 0, 0);

    return dDe > dAte;
  };

  const bloquearFiltroSeDataDmaisUmIndividual = data => {
    const amanha = new Date();
    amanha.setDate(amanha.getDate() + 1);
    amanha.setHours(0, 0, 0, 0);

    const isRetroativa = data => {
      if (!data) return false;

      const d = new Date(data);
      if (Number.isNaN(d.getTime())) return false;

      d.setHours(0, 0, 0, 0);
      return d < amanha;
    };

    // true = bloqueia se pelo menos uma for retroativa
    return isRetroativa(data);
  };

  return {
    filtros,
    anchorEl,
    id,
    open,
    handleOpen,
    handleClose,
    handleChange,
    handleFiltrar,
    handleLimpar,
    listaTipoOperacao,
    listaTipoDocumento,
    bloquearFiltroSeDataDmaisUm,
    bloquearFiltroSeDataDmaisUmIndividual,
    validaSeDataInicialMaiorQueFinal
  };
};

export default useFiltrosTabelaHook;
